import styled from "styled-components";
import { Input } from "antd";

export const Wrapper = styled(Input.TextArea)`
  width: 100%;
  padding: 8px 15px;
  font-size: 20px;
  border-radius: 3px;
  border: 2px solid transparent;
  outline: 1px solid transparent;
  ::placeholder {
    color: #2c3e50;
    font-size: 20px;
  }
  :hover {
    border: 2px solid black;
    outline: 1px solid #fff;
  }
`;
